import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { MANIFESTO } from "@/lib/content";
import { EASE } from "@/lib/motion";

export default function HeroPhilosophyTeaser() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const t = setInterval(() => {
      setIndex((i) => (i + 1) % MANIFESTO.length);
    }, 3200);
    return () => clearInterval(t);
  }, []);

  const goToPhilosophy = () => {
    const el = document.getElementById("manifesto");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const current = MANIFESTO[index];

  return (
    <motion.button
      onClick={goToPhilosophy}
      data-testid="hero-philosophy-teaser"
      initial={{ opacity: 0, y: 16 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.9, ease: EASE, delay: 1.3 }}
      className="group mt-6 w-full max-w-md text-left rounded-2xl border border-[#EAE4DA] bg-white/70 backdrop-blur-sm px-5 py-3.5 hover:border-[#D5B876] transition-colors duration-300"
    >
      <div className="flex items-center justify-between gap-3">
        <span className="text-[10px] tracking-[0.24em] uppercase text-[#2A5C5A]">
          Our Philosophy
        </span>
        <span className="inline-flex items-center gap-1 text-[10px] tracking-[0.2em] uppercase text-[#0B302F]/50 group-hover:text-[#2A5C5A] transition-colors">
          Explore
          <ArrowUpRight className="h-3 w-3 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" strokeWidth={1.5} />
        </span>
      </div>

      <div className="mt-2 flex items-start gap-3 min-h-[36px]">
        <AnimatePresence mode="wait">
          <motion.span
            key={current.no}
            className="font-serif text-xl text-[#D5B876]/90 tabular-nums shrink-0"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.4 }}
          >
            {current.no}
          </motion.span>
        </AnimatePresence>
        <AnimatePresence mode="wait">
          <motion.p
            key={current.title}
            data-testid="hero-philosophy-teaser-text"
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.5, ease: EASE }}
            className="font-serif text-base sm:text-lg leading-snug text-[#0B302F]"
          >
            {current.title}
          </motion.p>
        </AnimatePresence>
      </div>

      <div className="mt-2.5 flex items-center gap-1.5">
        {MANIFESTO.map((m, i) => (
          <span
            key={m.no}
            className={`h-1 rounded-full transition-all duration-300 ${
              i === index ? "w-6 bg-[#D5B876]" : "w-2.5 bg-[#EAE4DA]"
            }`}
          />
        ))}
      </div>
    </motion.button>
  );
}
